import React, {useCallback, useEffect} from 'react';
import * as S from './SeatUnavailableMsg/SeatUnavailableMsg.styles';
import Icon from '../../../../../stories/core-components/IconsSelector';

const ContentUnavailable = (props) => {
  return (
    <S.MsgWrapper>
      {props.iconName? <div>
        <Icon name ={props.iconName} styleProps={{width: '4.3rem', height: '3.6rem'}} />
      </div> :null}
  <S.MsgTxt>{props.text || "Data Not Available"}</S.MsgTxt> 
    </S.MsgWrapper>
  );
};
 
export default ContentUnavailable;
